import axios from 'axios';

// Create Axios instance with base config
const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': 'tnUEPhRSPG4SQUCllrvTsoiC5VuVIoEamCXDy0Mi2tj4XYKCSZgmeXaxmLdsHh7E',
  },
  timeout: 10000, // Optional: timeout after 10 seconds
});

// GET request
export const getCMSRequest = async (endpoint, params = {}) => {
  try {
    const response = await apiClient.get(endpoint, {params});
    return response.data;
  } catch (error) {
    console.error('GET request error:', error);
    throw error;
  }
};

// POST request
export const postCMSRequest = async (endpoint, data = {}) => {
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    console.error('POST request error:', error);
    throw error;
  }
};

// Delete request
export const deleteCMSRequest = async (endpoint, data = {}) => {
  try {
    const response = await apiClient.delete(endpoint, {params: data});
    return response.data;
  } catch (error) {
    console.error('Delete request error:', JSON.stringify(error));
    throw error;
  }
};
